import { Pipe, PipeTransform, inject } from '@angular/core';
import { remove } from 'remove-accents'; 'remove-accents'
import {  FacturaDTO } from 'src/app/Models/ApiV2/DocumentoDTO';
import { VariablesGlobalesService } from 'src/app/services/variables-globales.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
const lodash = require('lodash');

@Pipe({
    name: 'buscarfactura',
    standalone: true
})
export class BuscarFacturaPipe implements PipeTransform {
  variablesGlobales = inject(VariablesGlobalesService);

  private  arrayFiltrado:  FacturaDTO[] = [];
  private values : string[] = [];
  private acumulaFiltros:  FacturaDTO[] = []
  private acumuladoFinal:  FacturaDTO[] = []

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }




  transform(array:  FacturaDTO[], 
    texto: string , 
    fullArray: FacturaDTO[] ):  
    FacturaDTO[] {

    

    if (!array) {
      return array;
    }
    if (texto?.length == 0) {
      return array;
    }

    texto = remove(texto?.toLowerCase());
    console.log("texto buscar" ,texto)
    this.arrayFiltrado = fullArray
   

    this.values = texto.split(' ');


    this.values.forEach((value, index) => {

      this.acumulaFiltros = this.arrayFiltrado.filter((documento : FacturaDTO) => {
      return (
        // documento?.id.toString().includes(value) ||
        // documento?.registro.toString().includes(value) ||
      // this.evaluar(this.datePipe.transform(documento.fecha, 'dd/MM/yyyy')).includes(value) ||

        remove(this.evaluar(documento?.numeroDocumento?.toLowerCase())).includes(value) ||
        remove(this.evaluar(documento?.serie?.serie.toLowerCase())).includes(value) ||
        remove(this.evaluar(documento?.nombre?.toLowerCase())).includes(value) ||
        remove(this.evaluar(documento?.estadoTesoreriaTexto?.toLowerCase())).includes(value) ||
        moment(documento?.fecha).format('DD/MM/YYYY').includes(value)  

      );
      
    });
    if(index == 0) this.acumuladoFinal = this.acumulaFiltros
    else this.acumuladoFinal = lodash.intersectionBy(this.acumuladoFinal, this.acumulaFiltros, 'id')
    })
    this.variablesGlobales.elementosPipeFacturas = this.acumuladoFinal.length;
    return this.acumuladoFinal
  }

  evaluar(valor: string) : string {
    if (!valor) valor = "";
    return valor
  }

}
